module.exports = __webpack_public_path__ + "static/media/81.0f798685.jpg";